import { useCheckUserPermissions } from "../../../helpers/usePermissionManager";
import ErrorPage, { ErrorPageType } from "../../../pages/shared/error";

type DashboardPermissionCheckerProps = {
	children: React.ReactNode;
	permissions: string[];
	permissionRule: "OR" | "AND";
}

const DashboardPermissionChecker = ({ children, permissions, permissionRule }: DashboardPermissionCheckerProps) => {
    const { checkUserPermissionsAnd, checkUserPermissionsOr } = useCheckUserPermissions();
    const hasPermission = permissionRule === "OR" 
        ? checkUserPermissionsOr(permissions) 
        : checkUserPermissionsAnd(permissions);
        
    return (hasPermission 
        ? <>{children}</> 
        : <div className="grow flex justify-center items-center text-center">
            <div className="-translate-y-1/2">
                <h1 className="text-9xl max-md:text-5xl font-bold">404</h1>
                <p>ACCESS DENIED! You do not have permission to access this page.</p>
            </div>
        </div>
    );
}
 
export default DashboardPermissionChecker;